import { IContractorForm, useContractorForm } from '../../hooks/useContractorForm';
import { DrawerSvccCargando } from '../../../../components/drawer/DrawerSvcc';
import {
    DrawerSvccAyuda,
    DrawerSvccCuerpo,
    DrawerSvccEncabezado,
    DrawerSvccPie,
    DrawerSvccSeccion
} from '../../../../components/drawer/DrawerSvcc';
import CamposSvcc from '../../../../components/drawer/CamposSvcc';

const ContractorForm = ({ handleCloseDrawer, selected, isEditing, onlyVisual }: any) => {
    const contractorForm = useContractorForm({
        selectedContractor: selected,
        isEditing: isEditing,
        handleCloseDrawer: handleCloseDrawer
    });

    const {
        formData,
        contractorFieldsConfig,
        errors,
        isAddingContractor,
        isEditingContractor,
        handleChange,
        translate,
        handleSubmit
    } = contractorForm;

    return (
        <>
            <DrawerSvccEncabezado
                titulo={translate(
                    `responsiblesAndContractorsForms.newContractor.titles.${
                        isEditing ? 'edit' : 'new'
                    }`
                )}
                paso={translate('responsiblesAndContractorsForms.drawerPaso')}
                onCerrar={handleCloseDrawer}
            />
            <DrawerSvccCuerpo>
                {!onlyVisual && (
                    <DrawerSvccAyuda>
                        {translate('responsiblesAndContractorsForms.newContractor.ayuda')}
                    </DrawerSvccAyuda>
                )}
                <DrawerSvccSeccion
                    titulo={translate('responsiblesAndContractorsForms.newContractor.seccion')}
                >
                    <CamposSvcc
                        config={contractorFieldsConfig}
                        formData={formData as IContractorForm & Record<string, any>}
                        errors={errors}
                        onChange={handleChange}
                        onlyVisual={onlyVisual}
                    />
                </DrawerSvccSeccion>
            </DrawerSvccCuerpo>
            <DrawerSvccPie
                onCancelar={handleCloseDrawer}
                onConfirmar={handleSubmit}
                textoCancelar={translate('responsiblesAndContractorsForms.buttons.cancel')}
                textoConfirmar={translate('responsiblesAndContractorsForms.buttons.save')}
                nota={
                    onlyVisual
                        ? undefined
                        : translate('responsiblesAndContractorsForms.todosObligatorios')
                }
                cargando={isAddingContractor || isEditingContractor}
                sinConfirmar={onlyVisual}
            />
            <DrawerSvccCargando cargando={isAddingContractor || isEditingContractor} />
        </>
    );
};

export { ContractorForm };
